import { IEntryForm } from "@/types";

const ApiHelper = {
  getAwardsEntryBody: ({
    firstname,
    lastname,
    email,
    country,
    instagram,
    website,
    usageRights,
    recieveOffers,
    entries,
  }: IEntryForm) => ({
    data: {
      email,
      country,
      first_name: firstname,
      last_name: lastname,
      instagram_handle: instagram,
      photography_website: website,
      usage_rights: usageRights,
      receive_offers: recieveOffers,
      entries: entries.map(({ category, title, description, file }) => ({
        category,
        title,
        description,
        image_name: file?.name,
      })),
    },
  }),
};

export default ApiHelper;
